import * as React from 'react';
import { flow, forEach, size } from 'lodash';
import { II18nMessages } from '../../../../services/branding/models';
import { Button, Form } from 'react-bootstrap';
import { FieldArray, formValueSelector, InjectedFormProps, reduxForm } from 'redux-form';
import { IDeclaration, IProduct } from '../../../../data/api/models';
import Questions from './components/Questions';
import TravellersMedical from './components/TravellersMedical';
import { connect } from 'react-redux';
import { FaCog } from 'react-icons/fa';
import confirm from 'react-confirm2';
import { bindActionCreators } from 'redux';
import { actions as quoteActions } from '../../../../services/quote/reducer';
import { IQuoteActions } from '../../../../services/quote/models';
const Markdown = require('react-commonmark');

interface IMedicalDeclarationForm extends InjectedFormProps {
  i18n: II18nMessages;
  product: IProduct;
  pristine: boolean;
  submitting: boolean;
  onBack: () => void;
  medicalDeclaration: IDeclaration[];
  renderDefinition(name: string): any;
  actions: {
    quote: IQuoteActions;
  };
}

interface IMedicalDeclarationFormState {
  isScreening: boolean;
}

class MedicalDeclarationForm extends React.Component<IMedicalDeclarationForm, IMedicalDeclarationFormState> {
  public state = {
    isScreening: false,
  };

  public componentWillMount() {
    const { actions, schemeId, medicalDeclaration, product, change } = this.props;
    const steps = ['tripDetails', 'medicalDeclaration'];

    // console.log('product.metadata.medical_declaration_questions', product.metadata.medical_declaration_questions);

    if (size(medicalDeclaration) === 0) {
      change('medicalDeclaration', product.metadata.medical_declaration_questions);
    }

    if (!schemeId) {
      actions.quote.updateSteps(steps);
    }
  }

  public componentWillReceiveProps(nextProps) {
    const { medicalDeclaration, actions, dispatch, change, schemeId } = this.props;

    forEach(medicalDeclaration, (item, key) => {
      if (item.answer !== nextProps.medicalDeclaration[key].answer) {

        const steps = ['tripDetails', 'medicalDeclaration'];

        // TODO: Why do we need to set the schemeId to blank? this messes up loading a saved quote
        // if (schemeId) {
        //   dispatch(change('schemeId', ''));
        // }

        actions.quote.updateSteps(steps);
      }
    });
  }

  private shouldShowScreeningSection = () => {
    const { medicalDeclaration } = this.props;

    if (! medicalDeclaration) {
      return false;
    }

    const questions = medicalDeclaration.filter((question) => question.type === 'question');
    const unanswered = questions.filter((question) => question.answer === '');
    const trueAnswers = questions.filter((question) => question.answer === true);

    return unanswered.length === 0 && trueAnswers.length > 0;
  }

  private setIsScreening = (isScreening: boolean) => {
    this.setState({
      isScreening,
    });
  }

  private checkIfConditionWasDeclared = () => {
    const { travellers, medicalDeclaration } = this.props;

    const questions = medicalDeclaration.filter((question) => question.type === 'question');
    const unanswered = questions.reduce((acc, question) => acc && question.answer === undefined, true);
    const hastTrueAnswers = questions.reduce((acc, question) => acc || question.answer === true, false);
    const travellerScreening = travellers.filter((traveller) => traveller.screening);
    const travellersLength = travellers.length;
    const shouldScreen = ! unanswered && hastTrueAnswers;

    if (shouldScreen && travellerScreening.length < travellersLength && travellerScreening.length === 0) {
      this.setState({ isAnyModalOpen: true });
      confirm('Finish Medical Screening', {
        description: (
          <span>
            Warning - You cannot continue without declaring a medical condition.
            Please click on 'Add Conditions' button to add your conditions.
            <br/>
          </span>
        ),
        done: () => {
          this.setState({ isAnyModalOpen: false });
          return;
        },
        close: () => {
          this.setState({ isAnyModalOpen: false });
          return;
        },
      });
    }
  }

  public render() {
    const { i18n, product: { metadata }, handleSubmit, onBack, submitting, valid, change,
            medicalDeclaration, submitFailed } = this.props;

    if (! medicalDeclaration) {
      return false;
    }

    const { isAnyModalOpen } = this.state;

    return (
      <Form onSubmit={handleSubmit}>
        <div className="section">
          <h3>{i18n.quote.medicalDeclaration.title}</h3>
          <Markdown source={metadata.medical_declaration || ''} linkTarget="_blank" />
        </div>

        <div className="section" >
          <FieldArray
            name="medicalDeclaration"
            i18n={i18n}
            component={Questions}
            questions={metadata.medical_declaration_questions}
          />
        </div>

        <div className="section" hidden={!this.shouldShowScreeningSection()}>
          <h4>{i18n.quote.medicalDeclaration.condition}</h4>
          <h5>{i18n.quote.medicalDeclaration.screeningInstructions}</h5>

          <FieldArray
            name="travellers"
            i18n={i18n}
            change={change}
            component={TravellersMedical}
            questions={metadata.medical_declaration_questions}
            setIsScreening={this.setIsScreening}
          />
        </div>
        <div className="btn-bar" hidden={this.state.isScreening}>
          <Button
            bsStyle="primary"
            type="button"
            onClick={onBack}
          >
            Back
          </Button>
          <div className="pull-right">
            <Button
              bsStyle="primary"
              type="submit"
              onClick={this.checkIfConditionWasDeclared}
              disabled={submitting || (submitFailed && !valid) || isAnyModalOpen}
            >
              {submitting ? <FaCog className="fa-spin" /> : 'Next'}
            </Button>
          </div>
        </div>
      </Form>
    );
  }
}

let selector;

export default flow([
  reduxForm({
    form: 'quote',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    selector = formValueSelector('quote');

    return component;
  },
  connect(
    (state) => {
      const medicalDeclaration = selector(state, 'medicalDeclaration');
      const travellers = selector(state, 'travellers');
      const schemeId = selector(state, 'schemeId');

      return {
        schemeId,
        medicalDeclaration,
        travellers,
      };
    },
    (dispatch) => ({
      actions: {
        quote: bindActionCreators({ ...quoteActions }, dispatch),
      },
    }),
  ),
])(MedicalDeclarationForm);
